export const getUser = state => state.user;
export const getToken = state => state.user.token;
